/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react';
import {MutableList} from "./MutableList";
import {TagRemoveItemButton} from "./Buttons/TagRemoveItemButton";

export const StreamBankTagMutableList = (props) => {
    return <MutableList
        {...props}
        RemoveItemButton={TagRemoveItemButton}
    />;
};
